import { FC } from 'react';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  StyledCardTitle,
  StyledHeaderRow,
  StyledTag,
  StyledTitleGroup,
} from '../styled';
import { StatisticCardHeaderProps } from '../types';

const StyledInfoButton = styled(IconButton)({
  padding: 0,
});

const StyledInfoIcon = styled(InfoIcon)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(17),
  color: theme.palette.text.second,
}));

/**
 * Shared header component for all statistic cards
 * Displays title + info tooltip icon + optional tag badge
 */
export const StatisticCardHeader: FC<StatisticCardHeaderProps> = ({
  title,
  tooltip,
  tag,
}) => {
  return (
    <StyledHeaderRow>
      <StyledTitleGroup>
        <StyledCardTitle>{title}</StyledCardTitle>
        <Tooltip title={tooltip} arrow placement="top">
          <StyledInfoButton size="small">
            <StyledInfoIcon />
          </StyledInfoButton>
        </Tooltip>
      </StyledTitleGroup>

      {tag && <StyledTag label={tag.label} tagVariant={tag.variant} />}
    </StyledHeaderRow>
  );
};
